export const EVENT_TYPE_SMALL = 0;
export const EVENT_TYPE_LARGE = 1;

export const CALC_API_DEBOUNCE_DURATION = 500;

export const DATE_ERROR_MESSAGES = {
  inFuture: 'Eingegebenes Datum muss in der Zukunft liegen!'
};
